import { render } from "./DjNoShutdownTab.vue?vue&type=template&id=60fb74de&scoped=true"
import script from "./DjNoShutdownTab.vue?vue&type=script&lang=js"
export * from "./DjNoShutdownTab.vue?vue&type=script&lang=js"

import "./DjNoShutdownTab.vue?vue&type=style&index=0&id=60fb74de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60fb74de"

export default script